export const RoutePostStoresUpdateProducts = "/stores/update-products";
export type RoutePostStoresUpdateProducts = typeof RoutePostStoresUpdateProducts;

export interface PayloadPostStoresUpdateProducts {
  file: File;
  storeCodes: string[];
  categoryId: number;
}

export type ResponsePostStoresUpdateProducts = string;
